import React from 'react';
import { connect } from 'react-redux'; 
import { isEqual, cloneDeep } from '../../utils/lodash';

import { withStyles } from '@mui/styles';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import FilterIcon from '@mui/icons-material/FilterList';
import { Paper, Checkbox } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedOutlinedIcon from '@mui/icons-material/RadioButtonUncheckedOutlined';
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';

import CardAnalitics from '../../common/CardAnalitics';
import BubbleLoader from '../../common/BubbleLoader';
import CustomTabs from '../../common/CustonTabs';
import ComponentWrapper from "../../common/ComponentWrapper";
import TrplsTable from '../../common/TrplsTable/TrplsTable';
import CommonStyles from '../../common/CommonStyles';
import Filtration from './components/Filtration';
import LoaderNew from '../../common/LoaderNew';

import MatchedDriversToOrder from './components/MatchedDriversToOrder';

import { getJelData } from '../../reducer/jelsReducer';

import {
  nodesParams,
  boxParamsTable,
  prdcParamsTable,
  getUrlParameter,
  setUrlParameter,
  removeUrlParameter,
  decodeFilterFromUrl,
  trplsParamsTableMatching,
  getTransformedTrplsArrayToObj,
  getTransformedNodesArrayToObj,
} from '../../utils';

const notificationSound = new Audio('/audio/matching_alert.mp3');

// TODO make it env variables
// const DRIVER_ZIP_PREDICATE_ID = 1719;
const DRIVER_TABLE_ID = 350;
const ORDER_TABLE_ID = 351;
const PARSED_ORDER_TABLE_ID = 371;
const MATCHING_DRIVER_TABLE_ID = 372;

const VALID_MATCHING_PREDICATE_ID = 1737;

const MATCHED_ORDER_PREDICATE_ID = 1734;
const DRIVER_TRUCK_TYPE_PREDICATE_CHAIN_ID = [1730, 1727];
const DRIVER_CONCEPT_ID = 23978904;

const MATCHED_DRIVER_PREDICATE_ID = 1735;
const ORDER_CONCEPT_ID = 18721206;

const styles = {
  tableContainer: {
    marginBottom: '16px',
    overflow: 'auto',
    '&::-webkit-scrollbar': {
      width: '5px',
      height: '5px',
      background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      background:'rgb(129 134 169) !important',
    },
  },
  circle: {
    height: '30px',
    width: '30px',
    borderRadius: '30px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid #D9D8ED',
  },
  paperContainer: {
    paddingTop: '10px !important',
    // boxShadow: 'rgb(183 172 212 / 10%) 0px 1px 2px',
    // backgroundColor: '#ffffff70',
    borderRadius: '12px !important',
    margin: '30px',
  },
  actionMatching: {
    '&:hover': { backgroundColor: '#ffff !important' }
  },
  tableLoaderOverlay: {
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    zIndex: '200',
    display: 'flex',
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'rgba(255,255,255,0.8)',
  },
  checkbox: {
    height: '24px',
    width: '24px',
    color: '#347CFF',
    '& .MuiSvgIcon-root': {
      fontSize: '18px',
    },
  },
  linkText: {
    color: '#347CFF',
    cursor: 'pointer',
    width: 'fit-content',
    '&:hover': {
      borderBottom: '1px dashed #347CFF',
    },
  },
  iconInfo: {
    marginLeft: '4px',
    fontSize: '12px',
    color: '#347CFF',
    '&:hover': {
      color: '#347CFF !important',
      textDecoration: 'underline',
    },
  },
  controlButton: {
    color: '#3B3545',
    minHeight: '30px',
    height: 'fit-content',
    borderRadius: '15px',
    marginRight: '10px',
    textTransform: 'none',
    padding: '4px 15px 4px 10px',
    '&:hover': {
      color: '#3B3545',
      outline: '1px solid #D9D8ED',
    },
  },
  matchingAction: {
    height: '30px',
    width: '30px',
    marginRight: '-12px',
    opacity: 0.9,
    border: 'none',
    backgroundColor: '#121617',
    '&:hover': {
      opacity: 1
    }
  },
  matchIndex: {
    zIndex: 10,
    right: '30px',
    fontSize: 9,
    padding: '4px 9px',
    position: 'absolute',
    borderRadius: '15px',
    width: 'fit-content',
    backgroundColor: '#ffffff',
  },
  ...CommonStyles,
}

class MatchingPage2 extends ComponentWrapper {
  state = {
    data: null,
    newOrders: null,
    oldOrders: null,
    newDrivers: null,
    oldDrivers: null,
    autoupdate: true,
    driversTotal: null,
    accPlanPaid: true,
    notSeenMatches: [],
    thereIsFreshEmails: false,
    driverOrdersPairs: null,
    orderDriversPairs: null,
    oldOrderDriversPairs: [],
    oldDriverOrdersPairs: [],
    orderDriverPairs: null,
    playMatchSound: true,
    initialFilters: [],
    filterFromUrl: null,
    matchingMode: 'drivers',
    soundOnMatch: true,
    isPageInFocus: true,
    driversWithZips: 0,
    isFilterOpened: false,
    pageTitleIntervalId: null,
    isTabTextChangeWorking: false,
  }

  componentDidMount() {
    document.title = "Matching | Milkyweb";

    const { jels } = this.props;
    const filtersFromUrl = getUrlParameter('filters');

    document.addEventListener("visibilitychange", this.handleVisibilityChange);

    const filterFromUrl = filtersFromUrl
      ? JSON.parse(filtersFromUrl).map(decodeFilterFromUrl)
      : [];

    const viewIds = [DRIVER_TABLE_ID, ORDER_TABLE_ID, PARSED_ORDER_TABLE_ID, MATCHING_DRIVER_TABLE_ID];
    if (!jels.tables.includes(DRIVER_TABLE_ID || ORDER_TABLE_ID || PARSED_ORDER_TABLE_ID || MATCHING_DRIVER_TABLE_ID)) this.props.getJelData(viewIds);

    const matchingMode = getUrlParameter('by');
    const soundOnMatch = localStorage.getItem('match_sound') === 'false' ? false : true;

    if (matchingMode && matchingMode === 'orders') {
      this.setState({ matchingMode: 'orders', filterFromUrl, soundOnMatch }, () => this.updateDataOrders(filterFromUrl, true));
    } else {
      this.setState({ matchingMode: 'drivers', filterFromUrl, soundOnMatch }, () => this.updateData(filterFromUrl, true));
    }
    
    this.handleVisibilityChange();
  
    const matchingFilterFromLocalStorage = localStorage.getItem('matching_filter');
    const isFilterOpened = (!matchingFilterFromLocalStorage || matchingFilterFromLocalStorage === 'false') ? false : true;
  
    const autoUpdateFromLocalStorage = localStorage.getItem('matching_autoupdate');
    const autoUpdate = autoUpdateFromLocalStorage === 'false' ? false : true;
  
    if (autoUpdate) {
      this.setState({ autoupdate: autoUpdate }, () => this.changeAutoApdateCheckboxVal(autoUpdate));
    }

    if (isFilterOpened) {
      this.setState({ isFilterOpened });
    }
  
    this.getAccountPlanData();
  };

  getAccountPlanData = () => {
    const { setup } = this.props;

    const reqData = {
      nesting: 1,
      api_key: setup.id,
      filter: {
        limit: 1,
        ancestor: 26779687,
      },
    };

    this.postWithData({
      url: `/pnkqry3`,
      data: reqData,
      cb: (res) => {
        if (res && res._status === 'ok' && res.trpls && Object.values(res.trpls).length) {
          const trplsValues = Object.values(res.trpls);

          const accPlanPaid = trplsValues[0] && trplsValues[0][2094] && trplsValues[0][2094][0].val ? true : false;

          setTimeout(() => {
            this.setState({ accPlanPaid });
          }, 1500)
        }
      },
    });
  };

  componentWillUnmount = () => {
    const { intervalId, pageTitleIntervalId } = this.state;

    document.removeEventListener("visibilitychange", this.handleVisibilityChange);

    if (pageTitleIntervalId) window.clearInterval(pageTitleIntervalId);
    if (intervalId) window.clearInterval(intervalId);
  };

  updateDriversData = () => {
    const { setup } = this.props;

    const render = {
      trpl:{
        type:"a",
        params: trplsParamsTableMatching,
      },
      node:{
        type:"a",
        params: nodesParams,
      },
      prdc:{
        type:"a",
        params: prdcParamsTable,
      },
      box:{
        type:"a",
        params: boxParamsTable,
      }
    };

    const reqData = {
      render,
      nesting: 1,
      api_key: setup.id,
      show_pids: [1719],
      filter: {
        limit: 0,
        ancestor: DRIVER_CONCEPT_ID,
        trpls: [{ pids_chain: [1719], op: "is not null", con: "AND" }],
      },
    };

    this.postWithData({
      url: `/pnkqry3`,
      data: reqData,
      cb: (res) => {
        if (res && res._status === 'ok') {
          this.setState({ driversWithZips: res.total_query });

          if (!res.total_query) {
            const reqData = {
              render,
              nesting: 1,
              api_key: setup.id,
              show_pids: [1719],
              filter: {
                limit: 0,
                ancestor: DRIVER_CONCEPT_ID,
              },
            };
        
            this.postWithData({
              url: `/pnkqry3`,
              data: reqData,
              cb: (res) => {
                if (res && res._status === 'ok') {
                  this.setState({ driversTotal: res.total_query });
                }
              },
            });
          }
        }
      },
    });
  };

  checkIfEmailsComing = () => {
    const { setup } = this.props;

    const reqData = {
      nesting: 1,
      api_key: setup.id,
      filter: {
        limit: 1,
        ancestor: 24950203,
      },
    };

    this.postWithData({
      url: `/pnkqry3`,
      data: reqData,
      cb: (data) => {
        if (data._status === 'ok') {
          this.setState({ thereIsFreshEmails: data.total_query ? true : false });
        }
      }
    });
  };

  updateDataOrders = (filter, initialLoading) => {
    const { setup } = this.props;
    const { isPageInFocus, isTabTextChangeWorking } = this.state;

    const newDriversCopy = this.state.newDrivers ? cloneDeep(this.state.newDrivers) : [];
    const orderDriversPairsCopy = this.state.orderDriverPairs ? cloneDeep(this.state.orderDriverPairs) : [];

    let initialFilters = [
      { pids_chain: [MATCHED_DRIVER_PREDICATE_ID], op: "is not null", con: "AND" },
      { pids_chain: [MATCHED_DRIVER_PREDICATE_ID, VALID_MATCHING_PREDICATE_ID], val: "true", con: "AND" }
    ];

    if (filter && filter.length) {
      initialFilters.push(filter);
    }

    const reqData = {
      nesting: 4,
      api_key: setup.id,
      filter: {
        ancestor: ORDER_CONCEPT_ID,
        trpls: initialFilters,
      },
    };

    reqData.render = {
      trpl:{
        type:"a",
        params: trplsParamsTableMatching,
      },
      node:{
        type:"a",
        params: nodesParams,
      },
      prdc:{
        type:"a",
        params: prdcParamsTable,
      },
      box:{
        type:"a",
        params: boxParamsTable,
      }
    };

    // reqData.show_pids = [
    //   1598,1591,1658,1741,"1735.1740","1735.1737","1588.1617.1614","1589.1617.1614","1588.1600","1589.1600","1588.1604","1588.1632","1588.1623.1620",
    // ];

    reqData.show_pids = [1591,1598,1658,1735,1741,"1735.1734.1718","1735.1734.1719","1735.1734.1720","1735.1734.1721",
      "1735.1734.1722","1735.1734.1730.1724","1735.1734.1730.1725","1735.1734.1730.1726","1735.1734.1730.1727","1735.1734.1730.1728",
      "1735.1734.1730.1729","1735.1734","1735.1736","1735.1958","1735.1740","1735.1737","1735/2174","1588.1617.1614","1588.1599","1588.1600","1588.1601",
      "1589.1617.1614","1589.1599","1589.1600","1589.1601",
      "1588.1604","1588.1632","1588.1623.1620"];

    this.postWithData({
      url: `/pnkqry3`,
      data: reqData,
      cb: (data) => {
        if (data._status === 'ok') {
          data.nodes = getTransformedNodesArrayToObj(data.nodes, nodesParams);
          const orderDriverPairs = this.generateMatchedDriversPairs(data);
          const newDrivers = orderDriverPairs && orderDriverPairs.length ? orderDriverPairs.map(pair => pair[1]).flat() : [];
          const oldDrivers = initialLoading ? newDrivers : newDriversCopy;

          if (!isPageInFocus) {
            if (!orderDriverPairs || (orderDriverPairs && !orderDriverPairs.length)) {
              window.clearInterval(this.state.pageTitleIntervalId);
              this.setState({ notSeenMatches: [], pageTitleIntervalId: null });
            } else {
              const notSeenMatches = newDrivers.filter(nodeId => !oldDrivers.includes(nodeId));

              this.addToNotSeenMatches(notSeenMatches);
              if (!isTabTextChangeWorking && notSeenMatches && notSeenMatches.length) this.startShowNewMessages();
            }
          }

          this.setState({
            data: cloneDeep(data), 
            initialFilters,
            orderDriverPairs,
            playMatchSound: true,
            newDrivers,
            oldDrivers,
            oldOrderDriversPairs: initialLoading ? orderDriverPairs : orderDriversPairsCopy,
          });
        }
      },
    });
  };

  generateMatchedDriversPairs = (data) => {
    return data.query
      .map(orderPid => {
        const orderTrpls = getTransformedTrplsArrayToObj(data.trpls, orderPid, trplsParamsTableMatching);
        const matchedDrivers = (orderTrpls && orderTrpls[MATCHED_DRIVER_PREDICATE_ID]) || [];
        const matchedDriversOids = matchedDrivers
          .map(driverTrpl => +driverTrpl.oid)
          .filter(driverId => {
            return data.trpls[driverId][VALID_MATCHING_PREDICATE_ID]
              ? getTransformedTrplsArrayToObj(data.trpls, driverId, trplsParamsTableMatching)[VALID_MATCHING_PREDICATE_ID][0].val_bool
              : false;
          });
        return [orderPid, matchedDriversOids];
      })
      .filter(([_, matchedDriversOids]) => matchedDriversOids.length);
  };

  updateData = (filter, initialLoading) => {
    const { setup } = this.props;
    const { isPageInFocus, isTabTextChangeWorking } = this.state;

    const newOrdersCopy = this.state.newOrders ? cloneDeep(this.state.newOrders) : [];
    const driverOrdersPairsCopy = this.state.driverOrdersPairs ? cloneDeep(this.state.driverOrdersPairs) : [];

    let initialFilters = [
      { pids_chain: [MATCHED_ORDER_PREDICATE_ID], op: "is not null", con: "AND" },
      { pids_chain: [MATCHED_ORDER_PREDICATE_ID, VALID_MATCHING_PREDICATE_ID], val: "true", con: "AND" }
    ];

    if (filter && filter.length) {
      initialFilters.push(filter);
    }

    const reqData = {
      nesting: 5,
      api_key: setup.id,
      filter: {
        ancestor: DRIVER_CONCEPT_ID,
        trpls: initialFilters,
      },
    };

    reqData.render = {
      trpl:{
        type:"a",
        params: trplsParamsTableMatching,
      },
      node:{
        type:"a",
        params: nodesParams,
      },
      prdc:{
        type:"a",
        params: prdcParamsTable,
      },
      box:{
        type:"a",
        params: boxParamsTable,
      }
    };

    // reqData.show_pids = ["1734." + VALID_MATCHING_PREDICATE_ID,
    //   1718,1719,1720,1721,1722,"1730.1724","1730.1725","1730.1726","1730.1727","1730.1728","1730.1729"
    // ];
    reqData.show_pids = [MATCHED_ORDER_PREDICATE_ID, DRIVER_TRUCK_TYPE_PREDICATE_CHAIN_ID,
      1718,1719,1720,1721,1722,"1730.1724","1730.1725","1730.1726","1730.1727","1730.1728","1730.1729",
      "1734.1735","1734.1735.1658","1734.1735.1588.1617.1614","1734.1735.1588.1599","1734.1735.1588.1600","1734.1735.1588.1601",
      "1734.1735.1589.1617.1614","1734.1735.1589.1599","1734.1735.1589.1600","1734.1735.1589.1601",
      "1734.1735.1588.1604","1734.1735.1588.1632","1734.1735.1588.1623.1620","1734.1736","1734.1958","1734.2174","1734.1735.1741","1734.1735.1741","1734.1735.1591",
      "1734.1735.1598","1734.1740","1734." + VALID_MATCHING_PREDICATE_ID];

    this.postWithData({
      url: `/pnkqry3`,
      data: reqData,
      cb: (data) => {
        if (data._status === 'ok') {
          data.nodes = getTransformedNodesArrayToObj(data.nodes, nodesParams);
          const driverOrdersPairs = this.generateMatchedOrdersPairs(data);
          const newOrders = driverOrdersPairs && driverOrdersPairs.length ? driverOrdersPairs.map(pair => pair[1]).flat() : [];
          const oldOrders = initialLoading ? newOrders : newOrdersCopy;

          if (!isPageInFocus) {
            if (!driverOrdersPairs || (driverOrdersPairs && !driverOrdersPairs.length)) {
              window.clearInterval(this.state.pageTitleIntervalId);
              this.setState({ notSeenMatches: [], pageTitleIntervalId: null });
            } else {
              const notSeenMatches = newOrders.filter(nodeId => !oldOrders.includes(nodeId));

              this.addToNotSeenMatches(notSeenMatches);
              if (!isTabTextChangeWorking && notSeenMatches && notSeenMatches.length) this.startShowNewMessages();
            }
          }

          this.setState({
            data: cloneDeep(data),
            initialFilters,
            driverOrdersPairs,
            playMatchSound: true,
            oldOrders,
            newOrders,
            oldDriverOrdersPairs: initialLoading ? driverOrdersPairs : driverOrdersPairsCopy,
          });
        }
      },
    });
  };

  generateMatchedOrdersPairs = (data) => {
    return data.query
      .map(driverPid => {
        const driverTrpls = getTransformedTrplsArrayToObj(data.trpls, driverPid, trplsParamsTableMatching);
        const matchedOrders = (driverTrpls && driverTrpls[MATCHED_ORDER_PREDICATE_ID]) || [];
        const matchedOrdersOids = matchedOrders
          .map(orderTrpl => +orderTrpl.oid)
          .filter(orderId => {
            return data.trpls[orderId][VALID_MATCHING_PREDICATE_ID]
              ? getTransformedTrplsArrayToObj(data.trpls, orderId, trplsParamsTableMatching)[VALID_MATCHING_PREDICATE_ID][0].val_bool
              : false;
          });
        return [driverPid, matchedOrdersOids];
      })
      .filter(([_, matchedOrdersOids]) => matchedOrdersOids.length);
  };

  onModeTabChange = (value) => {
    setUrlParameter('by', value);
    removeUrlParameter('filters');

    this.setState({
      data: null,
      initialFilters: [],
      filterFromUrl: null,
      matchingMode: value,
    }, () => {
      if (value === 'orders') this.updateDataOrders([], true);
      else this.updateData([], true);
    });
  };

  changeAutoApdateCheckboxVal = (checked) => {
    localStorage.setItem('matching_autoupdate', checked);

    if (checked) {
      const newInterval = setInterval(() => {
        const closeModalIcon = document.getElementById('close-modal');
        if (closeModalIcon) return;

        const { matchingMode } = this.state;

        const filtersFromUrl = getUrlParameter('filters');

        const filterFromUrl = filtersFromUrl
          ? JSON.parse(filtersFromUrl).map(decodeFilterFromUrl)
          : [];

        if (matchingMode && matchingMode === 'orders') {
          this.updateDataOrders(filterFromUrl);
        } else {
          this.updateData(filterFromUrl);
        }
      }, 30000);

      this.setState({ intervalId: newInterval, autoupdate: checked });
    } else {
      const { intervalId } = this.state;

      if (intervalId) window.clearInterval(intervalId);
      this.setState({ autoupdate: checked });
    }
  };

  soundOnMatchChange = (checked) => {
    localStorage.setItem('match_sound', checked);

    this.setState({ soundOnMatch: checked });
  };

  handleVisibilityChange = () => {
    const { pageTitleIntervalId } = this.state;
    
    if (document.visibilityState === 'visible') {
      if (pageTitleIntervalId) window.clearInterval(pageTitleIntervalId);
      document.title = "Matching | Milkyweb";
      this.setState({ isTabTextChangeWorking: false });

      setTimeout(() => {
        const { notSeenMatches, newDrivers, newOrders, matchingMode } = this.state;

        let notSeenNewNodes = [];
        const currentNewNodes = matchingMode && matchingMode === 'orders' ? newDrivers : newOrders;

        if (currentNewNodes && currentNewNodes.length) {
          const visibleNodes = newOrders && newOrders.filter(nodeId => this.elementIsVisibleInViewport(nodeId));
          notSeenNewNodes = (visibleNodes && notSeenMatches) ? notSeenMatches.filter(nodeId => !visibleNodes.includes(nodeId)) : [];
        }

        this.setState({ notSeenMatches: [ ...notSeenNewNodes ] });
      }, 30000)

      this.updateDriversData();
      this.checkIfEmailsComing();
    }

    this.setState({ isPageInFocus: document.visibilityState === 'visible' });
  };

  elementIsVisibleInViewport = (elId, partiallyVisible = false) => {
    const el = document.getElementById(elId);
    if (!el) return;

    const { top, left, bottom, right } = el.getBoundingClientRect();
    const { innerHeight, innerWidth } = window;
    return partiallyVisible
      ? ((top > 0 && top < innerHeight) ||
          (bottom > 0 && bottom < innerHeight)) &&
          ((left > 0 && left < innerWidth) || (right > 0 && right < innerWidth))
      : top >= 0 && left >= 0 && bottom <= innerHeight && right <= innerWidth;
  };

  onHoverTable = (highlighNodes) => {
    setTimeout(() => {
      const { notSeenMatches } = this.state;
      
      highlighNodes && highlighNodes.length && highlighNodes.forEach(notSeenNodeId => {

        let notSeenNewNodes = notSeenMatches.filter(nodeId => notSeenNodeId !== nodeId);
        
        this.setState({ notSeenMatches: [ ...notSeenNewNodes ] });
      });
    }, 25000)
  };

  playMatchSound = () => {
    const { playMatchSound, soundOnMatch } = this.state;

    if (playMatchSound && soundOnMatch) {
      this.setState({ playMatchSound: false }, () => notificationSound.play());
    }
  };

  startShowNewMessages= () => {
    window.clearInterval(this.state.pageTitleIntervalId);

    this.setState({ isTabTextChangeWorking: true }, () => {
      let intervalFlag = false;
  
      let pageTitleIntervalId = setInterval(() => {
        const pageTitleStr = intervalFlag ? `New matches!` : '***';
  
        intervalFlag = !intervalFlag;
  
        document.querySelector('title').innerHTML = pageTitleStr;
      }, 1500);
  
      this.setState({ pageTitleIntervalId });
    });
  };

  addToNotSeenMatches = (nodesArr) => {
    const { notSeenMatches } = this.state;

    this.setState({ notSeenMatches: [ ...notSeenMatches, ...nodesArr] });
  };

  noMatchingDone = () => {
    const { driversTotal, driversWithZips, data, thereIsFreshEmails } = this.state;
    const { classes } = this.props;

    if (data === null) return;

    return (
      <div>
        <div>
          {driversWithZips && thereIsFreshEmails ?
            <div className={`${classes.flex} ${classes.mt30} ${classes.alignCenter}`}>
              <ErrorOutlineRoundedIcon className={classes.mr10} style={{ color: 'rgb(255, 170, 0)', fontSize: 18 }}/>
              <div className={`${classes.inlineGrid}`}>
                <span>Not found any matches at this time. Please, check later.</span>
                {/* <span>You can also add additional emails source or modify drivers settings.</span> */}
              </div>
            </div>
          : null}

          {!driversTotal && !driversWithZips ?
            <div className={`${classes.flex} ${classes.mt30} ${classes.alignCenter}`}>
              <ErrorOutlineRoundedIcon className={classes.mr10} style={{ color: 'rgb(255, 170, 0)', fontSize: 18 }}/>
              <span>There are no drivers created yet. Add your&nbsp;
                <a className={classes.linkText} target="_blank" rel="noreferrer" href={`/frm?id=355`}>
                  Drivers
                  <OpenInNewIcon className={classes.iconInfo}/>
                </a>
              </span>
            </div>
          : !driversWithZips ?
          <div className={`${classes.flex} ${classes.mt30} ${classes.alignCenter}`}>
            <ErrorOutlineRoundedIcon className={classes.mr10} style={{ color: 'rgb(255, 170, 0)', fontSize: 18 }}/>
            <span>There are no drivers with ZIP codes at the moment. Set ZIPs to drivers at&nbsp;
              <a className={classes.linkText} target="_blank" rel="noreferrer" href={`/frm?id=355`}>
                Drivers
                <OpenInNewIcon className={classes.iconInfo}/>
              </a>
            </span>
            </div>
          : null}
          
          {thereIsFreshEmails ? null :
            <div className={`${classes.flex} ${classes.mt30} ${classes.alignCenter}`}>
              <ErrorOutlineRoundedIcon className={classes.mr10} style={{ color: 'rgb(255, 170, 0)', fontSize: 18 }}/>
              <span>No emails received.</span>
            </div>
          }
        </div>
      </div>
    )
  };

  render() {
    const { jels, classes, setup } = this.props;
    const {
      data,
      oldOrders,
      oldDrivers,
      autoupdate,
      accPlanPaid,
      soundOnMatch,
      matchingMode,
      filterFromUrl,
      notSeenMatches,
      isFilterOpened,
      driversWithZips,
      orderDriverPairs,
      driverOrdersPairs,
      thereIsFreshEmails,
      oldDriverOrdersPairs,
      oldOrderDriversPairs
    } = this.state;

    const isMatchingRunning = driversWithZips > 0 && thereIsFreshEmails;

    return (
      <React.Fragment>
        <div className={`${classes.alignStartColumn} ${classes.m30}`} style={{ marginRight: !data ? '14px' : '' }}>
          <div className={`${classes.spaceBetween}`} style={{ width: '100%', marginLeft: '12px' }}>
            <div className={`${classes.alignEnd} ${classes.mb20}`}>
              <h2 className={classes.mr10} style={{ color: '#3B3545', whiteSpace: 'nowrap' }}>Matching </h2>
              
                <div
                  className={`${classes.alignCenter} ${classes.mr20}`}
                  style={{ marginBottom: '5px', marginLeft: '10px', fontSize: 11 }}
                >
                  {isMatchingRunning ?
                    <div className={`${classes.flex} ${classes.alignCenter}`}>
                      <div className={classes.mr5}>
                        <BubbleLoader/>
                      </div>
                      <span style={{ color: 'green' }}>Running</span>
                    </div>
                  : 
                    <div className={`${classes.flex} ${classes.alignCenter}`} style={{ marginBottom: '2px' }}>
                      <div style={{ marginRight: '8px', marginBottom: '1px' }}>
                        <div style={{ width: '12px', height: '12px', borderRadius: '10px', backgroundColor: 'rgb(255, 162, 0)' }}></div>
                      </div>
                      <span style={{ color: 'rgb(227, 152, 1)' }}>Not running</span>
                    </div>
                  }
                </div>
            </div>

            <div className={`${classes.relative} ${classes.flex}`} style={{ top: '-10px', right: '15px', zIndex: 100 }}>
              <CardAnalitics
                cardStyle="rounded"
                icon={
                  <div style={{ width: '10px' }}>
                    <span style={{ color: driversWithZips > 0 ? 'green' : 'red', fontSize: 13, fontWeight: 600 }}>{driversWithZips}</span>
                  </div>
                }
                text={'Drivers with ZIPs'}
                button={
                  <div className={`${classes.circle} ${classes.pointer} ${classes.matchingAction}`}
                    onClick={() => window.open(`http://${window.location.host}/frm?id=355`, '_blank')}
                  >
                    <OpenInNewIcon style={{ fontSize: 14, color: '#ffff' }}/>
                  </div>
                }
              />
              <CardAnalitics
                cardStyle="rounded"
                icon={
                  <Checkbox
                    margin="none"
                    color="default"
                    disabled={data === null}
                    value={autoupdate}
                    checked={autoupdate}
                    icon={<RadioButtonUncheckedOutlinedIcon style={{  marginLeft: '-5px' }}/>}
                    checkedIcon={<CheckCircleIcon style={{ color: 'green', marginLeft: '-5px' }}/>}
                    className={`${classes.checkbox} ${classes.pointer}`}
                    style={{ width: '1px' }}
                    onChange={(e) => {
                      this.changeAutoApdateCheckboxVal(e.target.checked);
                    }}
                  />
                }
                text={'Auto update every 30s'}
                button={null}
              />
              <CardAnalitics
                cardStyle="rounded"
                icon={
                  <Checkbox
                    margin="none"
                    color="default"
                    disabled={data === null}
                    value={soundOnMatch}
                    checked={soundOnMatch}
                    icon={<RadioButtonUncheckedOutlinedIcon style={{  marginLeft: '-5px' }}/>}
                    checkedIcon={<CheckCircleIcon style={{ color: 'green', marginLeft: '-5px' }}/>}
                    className={`${classes.checkbox} ${classes.pointer}`}
                    style={{ width: '1px' }}
                    onChange={(e) => {
                      this.soundOnMatchChange(e.target.checked);
                    }}
                  />
                }
                text={'Make sound on match'}
                button={null}
              />
           
            </div>
          </div>
            
          <div className={classes.alignEnd}>
            <div>
              <CustomTabs
                activeTab={matchingMode}
                tabs={["drivers","orders"]}
                labels={["by Drivers", "by Orders"]}
                onTabChange={(value) => {
                  this.onModeTabChange(value);
                }}
              />
            </div>
            <div
              className={`${classes.ml20} ${classes.mr10} ${classes.pointer} ${classes.circle} ${classes.actionMatching}`}
              style={{ backgroundColor: (isFilterOpened || (filterFromUrl && filterFromUrl.length)) ? '#fff' : ''}}
              onClick={() => {
                const newOpen = !this.state.isFilterOpened;
              
                this.setState({
                  isFilterOpened: newOpen,
                });
              
                localStorage.setItem("matching_filter", newOpen);
              }}              
            >
              <FilterIcon style={{ fontSize: '15px' }}/>
            </div>
            {data !== null && data.nodes && isFilterOpened ?
              <div className={classes.absolute} style={{ left: '400px', top: '50px', zIndex: 100 }}>
                <Filtration
                  setup={setup}
                  classes={classes}
                  onClose={() => {
                    this.setState({ isFilterOpened: false });
                    localStorage.setItem("matching_filter", false);
                  }}
                  setFilterToParentState={(filter) => {
                    this.setState({ filterFromUrl: filter });
                  }}
                  updateData={matchingMode === 'drivers' ? this.updateData : this.updateDataOrders}
                  concept={matchingMode === 'drivers' ? DRIVER_CONCEPT_ID : ORDER_CONCEPT_ID}
                  filterBtnText="Filter"
                  filterByNodeTitle={false}
                  nodes={data.nodes}
                  filterFromUrl={filterFromUrl}
                  showPidsIds={
                    [matchingMode === 'drivers' ? DRIVER_TRUCK_TYPE_PREDICATE_CHAIN_ID : 1591]
                  }
                />
              </div>
            : null}
          </div>
        </div>

        {!matchingMode || matchingMode === 'drivers' ?
          <React.Fragment key={'drivers'}>
            {!driverOrdersPairs && (
              <div className={classes.tableLoaderOverlay}>
                <LoaderNew />
              </div>
            )}
          {data && jels.jelData && jels.jelData[DRIVER_TABLE_ID] && jels.jelData[ORDER_TABLE_ID] && driverOrdersPairs && driverOrdersPairs.length
            ? driverOrdersPairs.map(([driverPid, matchedOrdersOids], index) => {
              const nodeNotSeen = matchedOrdersOids.filter(nodeId => notSeenMatches.includes(+nodeId)); //generally not seen nodes (because not on user screen)
              const nodesToHighlight = matchedOrdersOids.filter(nodeId => !oldOrders.includes(+nodeId)); //fresh not seen nodes (came on the last update)
              const oldDriverOrderPair = oldDriverOrdersPairs && oldDriverOrdersPairs.find(pair => pair.includes(+driverPid));
              const oldMatchedOrdersOids = oldDriverOrderPair && oldDriverOrderPair[1];
              const shouldTableUpdate = nodesToHighlight.length || !oldMatchedOrdersOids || !isEqual(oldMatchedOrdersOids, matchedOrdersOids) ? true : false;

              if (nodesToHighlight && nodesToHighlight.length) this.playMatchSound();

              const notSeenNodes = [ ...nodesToHighlight, ...nodeNotSeen ];

              return (
                <div key={driverPid}>
                  <div className={classes.matchIndex}>
                    {index + 1}
                  </div>
                <Paper key={driverPid} id={driverPid} elevation={0} className={`${classes.paperContainer} ${classes.glassBGMedium}`}>
                  <div className={`${classes.tableContainer}`}>
                    <TrplsTable
                      isEmbed
                      smallHeadingBtns={true}
                      customSTitle={'Driver'}
                      preloadedData={
                        {
                          ...data,
                          total_query: 1,
                          query: [driverPid],
                        }
                      }
                      updateFilter={{
                        nodes: [driverPid],
                      }}
                      tableGroupIndex={driverPid + '-driver'}
                      settings={jels.jelData[DRIVER_TABLE_ID]}
                    />
                  </div>

                  <div
                    className={classes.tableContainer}
                    onMouseEnter={() => this.onHoverTable(notSeenNodes)}
                  >
                    <TrplsTable
                      isEmbed
                      whiteRows={true}
                      smallHeadingBtns={true}
                      customSTitle={'Orders'}
                      preloadedData={
                        {
                          ...data,
                          total_query: matchedOrdersOids.length,
                          query: cloneDeep(matchedOrdersOids).reverse(),
                        }
                      }
                      //usePreloadedQuery={true}
                      forceUpdateTable={shouldTableUpdate}
                      nodeToHighlight={notSeenNodes}
                      updateFilter={{trpls: [{pids_chain: [MATCHED_ORDER_PREDICATE_ID], val: driverPid}
                                              ]}} //{pids_chain: [VALID_MATCHING_PREDICATE_ID], val: true}
                      tableGroupIndex={driverPid + '-orders'}
                      settings={jels.jelData[ORDER_TABLE_ID]}
                    />
                  </div>
                </Paper>
                </div>
              )
            }) : 
              <div className={`${classes.justifyCenter} ${classes.mt20}`}>
                <span>{this.noMatchingDone()}</span>
              </div>
            }
          </React.Fragment>
        :
          <React.Fragment key={'orders'}>
            {!orderDriverPairs && (
              <div className={classes.tableLoaderOverlay}>
                <LoaderNew />
              </div>
            )}
            {data && jels.jelData && jels.jelData[MATCHING_DRIVER_TABLE_ID] && jels.jelData[PARSED_ORDER_TABLE_ID] && orderDriverPairs && orderDriverPairs.length
              ? orderDriverPairs.map(([orderPid, matchedDriverOids], index) => {
                const nodeNotSeen = matchedDriverOids.filter(nodeId => notSeenMatches.includes(+nodeId)); //generally not seen nodes (because not on user screen)
                const nodesToHighlight = matchedDriverOids.filter(nodeId => !oldDrivers.includes(+nodeId)); //fresh not seen nodes (came on the last update)
                const oldOrderDriverPair = oldOrderDriversPairs && oldOrderDriversPairs.find(pair => pair.includes(+orderPid));
                const oldMatchedDriversOids = oldOrderDriverPair && oldOrderDriverPair[1];
                const shouldTableUpdate = nodesToHighlight.length || !oldMatchedDriversOids || !isEqual(oldMatchedDriversOids, matchedDriverOids) ? true : false;

                if (nodesToHighlight && nodesToHighlight.length) this.playMatchSound();

                return (
                  <div key={orderPid}>
                    <div className={classes.matchIndex}>
                      {index + 1}
                    </div>
                    <Paper key={orderPid} id={orderPid} elevation={0} className={`${classes.glassBGMedium} ${classes.paperContainer}`}>
                      <MatchedDriversToOrder
                        data={data}
                        jels={jels}
                        classes={classes}
                        orderPid={orderPid}
                        onHoverTable={this.onHoverTable}
                        nodeToHighlight={[ ...nodesToHighlight, ...nodeNotSeen ]}
                        shouldTableUpdate={shouldTableUpdate}
                        matchedDriverOids={matchedDriverOids}
                        PARSED_ORDER_TABLE_ID={PARSED_ORDER_TABLE_ID}
                        MATCHING_DRIVER_TABLE_ID={MATCHING_DRIVER_TABLE_ID}
                        MATCHED_DRIVER_PREDICATE_ID={MATCHED_DRIVER_PREDICATE_ID}
                        VALID_MATCHING_PREDICATE_ID={VALID_MATCHING_PREDICATE_ID}
                      />
                    </Paper>
                  </div>
                )
              }) : 
              <div className={`${classes.justifyCenter} ${classes.mt20}`}>
                <span style={{ color: '#4c4c4c' }}>{this.noMatchingDone()}</span>
              </div>
            }
          </React.Fragment>
        }
      </React.Fragment>
    )
  }
};

export default connect((state) => (
  {
    jels: state.jels,
    setup: state.meta.setup,
  }
), { getJelData })(withStyles(styles)(MatchingPage2));
